import React from "react";

import SkipLink from "./components/SkipLink";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import Process from "./components/Process";
import Stats from "./components/Stats";
import Portfolio from "./components/Portfolio";
import Pricing from "./components/Pricing";
import Team from "./components/Team";
import Contact from "./components/Contact";
import LegalSection from "./components/LegalSection";
import Footer from "./components/Footer";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import ChatBot from "./components/ChatBot";

function App() {
  return (
    <div className="app">
      <SkipLink />
      <Navbar />

      <main id="main-content">
        <Hero />

        <TrustBar />

        <Services />

        <Process />

        <Stats />

        <Portfolio />

        <Pricing />

        <Team />

        <Contact />

        <LegalSection />
      </main>

      <Footer />

      <ChatBot />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
